import React, { useState } from 'react';
import { useGlobalEvent } from 'beautiful-react-hooks';
import { useHistory, useParams } from 'react-router-dom';
import StartLivingOola from './HomePage/StartLivingOola/StartLivingOola';
import GetStarted from './HomePage/GetStarted/GetStarted';
import FooterSection from './LearnMore/FooterSection/FooterSection';
import LoginHeader from './Common/LoginHeader/LoginHeader';
import ExigoHeader from './Common/ExigoHeader/ExigoHeader';
import TestimonialsSection from './LearnMore/TestimonialsSection/TestimonialsSection';
import ChangingWorldSection from './LearnMore/ChangingWorldSection/ChangingWorldSection';
import StartYourJourneySection from './LearnMore/StartYourJourneySection/StartYourJourneySection';
import StartYourJourney from './HomePage/StartYourJourney/StartYourJourney';
import PublicProfile from './HomePage/PublicProfile/PublicProfile';
import Products from './HomePage/V2/Products/Products';
import Programs from './HomePage/V2/Programs/Programs';
import OolaServices from './HomePage/V2/OolaServices/OolaServices';
import FreeTest from './HomePage/V2/FreeTest/FreeTest';
import config from '../config.json';
import TheBlue from './HomePage/V2/TheBlue/TheBlue';

const HomePage = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const onWindowResize = useGlobalEvent('resize');
    const [mobile, setMobile] = useState(window.innerWidth <= 760);
    onWindowResize((event: React.SyntheticEvent) => {
        setMobile(window.innerWidth <= 768);
        setWindowWidth(window.innerWidth);
    });
    const history = useHistory();
    const { webAlias } = useParams();

    function goEnroll() {
        if (webAlias) history.push(`/learnmore/myoola/${webAlias}`);
        else history.push('/learnmore');
    }
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let isExigo = params.get('exigo');

    function goEnrollment() {
        if (webAlias)
            window.location.href = `${config.enrollmentURL}/${webAlias}/enrollment`;
        else
            window.location.href = `${config.enrollmentURL}/corporphan/enrollment`;
    }
    function goCourse(course) {
        window.location.href = `${config.ADDITIONALCOURSESERVER}/${course}`;
    }
    function goProduct(product) {
        window.location.href = `${config.OOLAPRODUCTS}/${product}`;
    }
    function goProducts() {
        window.location.href = `${config.ADDITIONALCOURSESSERVER}`;
    }
    function goFreeTest() {
        window.location.href = webAlias
            ? `${config.SERVER_URL_BASE}FreeTest/${webAlias}`
            : `${config.SERVER_URL_BASE}FreeTest`;
    }
    function goLifeStyleFrameWork() {
        window.location.href = `${config.OOLALIFEFRAMEWORKLINK}`;
    }
    return (
        <>
            {isExigo === '1' ? (
                <div className='exigoHeaderSpacing'/>
                ) : (
                <LoginHeader
                    goEnroll={goEnrollment}
                    isDarkLogo
                    enrollButtonText="ENROLL"
                    setMobile={setMobile}
                    mobile={mobile}
                />
            )}

            <StartYourJourneySection
                goEnroll={goEnroll}
                enrollButtonText="JOIN US"
            />
            {webAlias && <PublicProfile webAlias={webAlias} />}
            <StartYourJourney goEnroll={goEnroll} enrollButtonText="JOIN US" />
            <TheBlue goFreeTest={goFreeTest} />


            <Products goProduct={goProduct} />
            <Programs goEnroll={goEnroll} />
            <OolaServices
                goEnroll={goEnroll}
                goCourse={goCourse}
                goLifeStyleFrameWork={goLifeStyleFrameWork}
            />
            <StartLivingOola
                goEnroll={goEnroll}
                goProducts={goProducts}
                mobile={mobile}
            />
            <FreeTest goFreeTest={goFreeTest} />
            <GetStarted goEnroll={goEnroll} />

            <TestimonialsSection optionApi={0} webAlias={webAlias} />
            <ChangingWorldSection
                goEnroll={goEnroll}
                enrollButtonText="JOIN US"
                webAlias={webAlias}
            /> 
            <FooterSection goEnroll={goEnroll} />
        </>
    );
};

export default HomePage;
